import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  shuttle: {
    width: 44,
    height: 44,
    objectFit: 'contain',
  },
});

export const LogoIcon = () => {
  const classes = useStyles();
  return (
    <img src="/shuttle.png" alt="Silk.Shuttle" className={classes.shuttle} />
  );
};
